<div class="row">
    <div class="col">
        The maximum limit reached , please enter the quanity within the limit value
    </div>
</div>
<div class="row">
    <div class="col" >
        <button mat-raised-button (click)="closeBox()">OK</button>
    </div>
</div>